<nz-page-header [nzGhost]="true">
  <nz-page-header-title>
    <div class="module-header">
      @if ($any(form)?.iconName) {
        <div class="icon">
          <app-icon [iconName]="$any(form)?.iconName"></app-icon>
        </div>
      }
      <div>
        @if ($any(form)?.canGoBack?.()) {
          <div
            (click)="form?.goBackForm?.()"
            (keydown.enter)="form?.goBackForm?.()"
            tabindex="0"
            role="button"
            class="goBackAction"
          >
            <span class="backIcon"><app-icon iconName="back2"></app-icon></span>
            <span class="goBackText">Atrás</span>
          </div>
        }
        <span class="title">{{ showTitle ? form?.title : '' }}</span>
        <div class="subtitle">
          @if (form.customAttributes?.['breadCrumbs']?.length > 0) {
            @for (item of form.customAttributes?.['breadCrumbs']; track $index; let last = $last) {
              <span>
                {{ `${item}` }}
                @if (!last) {
                  <span class="bcSeparator">&#8226;</span>
                }
              </span>
            }
          } @else {
            <div class="subtitle-lines">
              <span class="subtitle-description">{{ description ?? form?.description ?? '' }}</span>
              @if (lastLogin) {
                <span class="last-login">Último ingreso: {{ lastLogin }}</span>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </nz-page-header-title>

  <!-- Acciones -->
  <nz-page-header-extra>
    <!-- La campana recibe el formulario anfitrión para que, al abrir el detalle
         de notificaciones, el "Atrás" regrese a este formulario. -->
    <app-notifications-bell [hostForm]="form"></app-notifications-bell>

    @for (item of $any(form)?.visibleHeaderActions | slice: 0 : 3; track $index) {
      <app-action [action]="item"></app-action>
    }

    @if ($any(form)?.visibleHeaderActions?.length === 4) {
      @for (item of $any(form)?.visibleHeaderActions | slice: 3 : 1; track $index) {
        <span class="btnContainer">
          <app-action [action]="item"></app-action>
        </span>
      }
    }

    @if ($any(form)?.visibleHeaderActions?.length > 4) {
      <span class="btnContainer">
        <button nz-button nzNoAnimation nz-dropdown [nzDropdownMenu]="menu" style="border: none; padding: 0">
          <app-icon iconName="ELLIPSIS" nzTheme="outline" style="font-size: 20px; vertical-align: top"></app-icon>
        </button>
      </span>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
          @for (item of $any(form)?.visibleHeaderActions | slice: 3; track $index) {
            @if (item.visible) {
              <li
                nz-menu-item
                [nzDisabled]="item?.disabled"
                (click)="form.startAction(item.actionCode)"
                (keydown.enter)="form.startAction(item.actionCode)"
                tabindex="0"
                role="menuitem"
              >
                {{ item.actionName }}
              </li>
            }
          }
        </ul>
      </nz-dropdown-menu>
    }
  </nz-page-header-extra>
</nz-page-header>
